import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Row, Col} from 'react-grid-system'
import sadDogImg from './unsubscribe.webp'
import {getParameterByName} from "../../js/helpers/functions";
import axios from "axios";

const Unsubscribe = (props) => {
	const [unsubscribed, setUnsubscribed] = useState(false);
	const [email, setEmail]               = useState(null);
	useEffect(() => {

		let param = getParameterByName('email', window.location.href);
		if (param) {
			setEmail(param)
		}
	}, []);
	return (
		<div style={{padding: '80px 10px'}}>
			<Row justify={'center'}>
				<Col md={9} style={{justifyContent: 'center', textAlign: 'center'}}>
					<h3>We're sad to see you go</h3>
					<img src={sadDogImg} style={{width: '350px'}}/>
				</Col>
			</Row>
			<Row justify={'center'}>
				<Col md={3}>
					{!unsubscribed && email && <div onClick={() => {
						window.location.href = '/'
					}} className="downloadButton" aria-disabled="false">
						<span className="downloadText">ok, i'll stay</span>
					</div>}
					{email && !unsubscribed && <div style={{marginTop: '10px'}} onClick={async () => {
						let response = await axios({
							method: 'post',
							url: process.env.REACT_APP_API_URL + '/customer/unsubscribe',
							headers: {"Content-Type": "application/json"},
							data: {email}
						});
						if (response.data && response.data.success) {
							setUnsubscribed(true);
						}
					}} aria-disabled="false">
						<span style={{textTransform: 'capitalize', cursor: 'pointer'}}>Unsubscribe</span>
					</div>}
					{unsubscribed && <h4>You are now unsubscribed.</h4>}
				</Col>
			</Row>
		</div>
	)

}

const mapStateToProps = (state) => {
	      return {
		      config: state.rootReducer.config,
	      };
      }
;
export default connect(mapStateToProps)(Unsubscribe);
